import * as React from 'react'
import { MdDate, MdClientSelect, MdErrors, MdButton } from '../widgets'
import { translate } from 'react-translate'
const moment = require('moment')
import { TimeFormat } from '../../../ts/enums'
class AccountStatementContainer extends React.Component<AccountStatementContainerProps, AccountStatementContainerState> {
  constructor(props) {
    super(props)
    this.state = {
      startDate: new Date(moment().subtract(1, 'months')),
      endDate: new Date(moment().endOf('day').toDate()),
      accountId: null,
      errors: []
    }
  }

  private formatISOOffsetDate(d) {
    return moment(d).format(TimeFormat).replace('+', '%2B')
  }

  private loadAccountStatement() {
    if (this.state.errors.length > 0){ return false }
    var formData = {
      dateStart: this.formatISOOffsetDate(this.state.startDate),
      dateEnd: this.formatISOOffsetDate(this.state.endDate),
      accountId: this.state.accountId
    }

    if (!formData.dateStart || !formData.dateEnd) {
      return false
    }

    if (!formData.accountId) {
      var accounts = window['md3'].account.filter()
      if(accounts.length === 1) {
        formData.accountId = accounts[0].id
      } else {
        this.setState({
          errors: [{detail: 'Please select a client.'}]
        })
        return false
      }
    }

    var languageCode = this.props.language

    window.open(
      '/md3api/reports/accountStatement.pdf?' +
      'languageCode=' + languageCode +
      '&accountId=' + formData.accountId +
      '&openingDate=' + formData.dateStart +
      '&closingDate=' + formData.dateEnd +
      '&marketplaceId=' + window['md3'].marketplace.getActive().id)
  }

  public render() {
    let t = this.props.t
    return (
      <div>
        <form>
            <header className="report-toolbar">
            <MdClientSelect
              hideHouse={false}
              hideIbs={false}
              onAccountChange={(account) => {
                  if (account) {
                    this.setState({ accountId: account.id, errors: [] })
                  } else {
                    this.setState({ accountId: null })
                  }
                }
              } />
            </header>
            <fieldset>
                <legend>{t('SELECT_DATE_RANGE')}</legend>
                <section className="settings-block statements">
                    <div className="date-range">
                      <MdDate
                        container='#picker-container-start'
                        onChange={(startDate) => this.setState({ startDate: startDate })}
                        name='Start Date'
                        id='start-date'
                        inputStyle={{width: '100%'}} />
                      <MdDate
                        container='#picker-container-end'
                        onChange={(endDate) => this.setState({ endDate: endDate })}
                        name='End Date'
                        id='end-date'
                        isEndDate={true}
                        inputStyle={{width: '100%'}} />
                    </div>
                </section>
            </fieldset>
            <div id='picker-container-start' />
            <div id='picker-container-end' />
            <footer className="nav-block">
              <MdButton clickHandler={() => this.loadAccountStatement() } text={t('RUN_REPORT')} />
            </footer>
        </form>
        <div style={{marginBottom: '30px'}}>
          {
            this.state.errors.length > 0 ?
              <MdErrors errors={this.state.errors} /> : null
          }</div>
      </div>
    )
  }
}

export default translate('AccountStatementContainer')(AccountStatementContainer)



// WEBPACK FOOTER //
// ./react/components/containers/AccountStatementContainer.tsx